angular
  .module("AccountingBoxApp")
  .controller("EditBankAccountCtrl", function(
    $scope,
    $state,
    $filter,
    Sale,
    $stateParams,
    BankAccount
  ) {
    var vm = this;
    var bankAccount;
    $scope.isNewBankAccount = false;

    vm.securePlaceholder = function(bankAccount) {
      if (!$scope.isNewBankAccount) {
        return "************";
      } else {
        return "";
      }
    };
    vm.ibanChanged = function(bankAccount) {
      if (bankAccount.bankAccountNumber) {
        var bankShort = bankAccount.bankAccountNumber.substring(4, 8);
        var bank;
        switch (bankShort) {
          case "SNSB":
            bank = "SNS Bank";
            break;
          case "ABNA":
            bank = "ABN AMRO";
            break;
          case "INGB":
            bank = "ING";
            break;
          case "RABO":
            bank = "Rabobank";
            break;
          case "ASNB":
            bank = "ASN Bank";
            break;
          case "KNAB":
            bank = "Knab";
            break;
          case "TRIO":
            bank = "Triodos Bank";
            break;
          case "RBRB":
            bank = "RegioBank";
            break;
          case "FVLB":
            bank = "Van Lanschot";
            break;
          case "BUNQ":
            bank = "Bunq";
            break;
          case "MOYO":
            bank = "Moneyou";
            break;
          default:
            bank = "";
            break;
        }
        if (bankAccount.bankAccountNumber.indexOf("NL30ABNA0524590958") > -1) {
          bank = "Mollie";
        }
        bankAccount.bankName = bank;
        bankAccount.bankCode = bankShort;
      }
      // body...
    };
    vm.save = function(bankAccount) {
      $scope.submitted = true;
      var bA = new BankAccount(bankAccount);
      bA.$save().then(function() {
        // if(vm.newContact){
        //    $scope.$emit('bankAccountAdded', bankAccount);
        // }else{
        // console.log('bankaccount saved');
        $scope.$emit("bankAccountSaved", bankAccount);
        if ($scope.isNewBankAccount) {
          analytics.track("Added Bankaccount", { bank: bankAccount.bankName });
        }
        $scope.$emit("closeBankAccount", null);
      });
    };

    $scope.$on("editBankAccount", function(e) {
      // console.log('received edit bank account id:', $scope.bankAccount);
      bankAccount = BankAccount.get({
        id: $scope.bankAccount.id
      });
      $scope.isNewBankAccount = false;
      vm.bankAccount = bankAccount;
    });

    $scope.$on("newBankAccount", function(e) {
      //  console.log('newBAnkAccount received');
      bankAccount = new BankAccount();
      $scope.isNewBankAccount = true;
      bankAccount.bankType = "business";
      vm.bankAccount = bankAccount;
    });

    vm.cancel = function() {
      $scope.$emit("closeBankAccount", null);
    };

    // console.log('vm purchase');
    vm.removeBankAccountConfirmation = function(bankAccount) {
      $scope.$emit("removeBankAccountConfirmation", bankAccount);
      //  console.log('removepurchase open modal');
    };
  });
